// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { creditCardDetailsEntryStyles } from "@rpsc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import IconQuestionTooltip from "@rpsc/XDL/Icons/IconQuestionTooltip";
import { createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

creditCardDetailsEntryStyles.cardTypeTokenExText = creditCardDetailsEntryStyles.cardTypeSpreedlyText = {
    size: 14,
    lineHeight: "22px",
    weight: "bold",
};

creditCardDetailsEntryStyles.container = {
    css: css`
        position: relative;
        display: flex;
        flex: 1;
    `,
};

creditCardDetailsEntryStyles.securityCodeGridItemOnePageCheckout = {
    width: [12, 12, 12, 4, 4],
};
creditCardDetailsEntryStyles.expirationDateContainer = {
    gap: 22,
    offsetCss: css`
        align-items: baseline;
    `,
};
creditCardDetailsEntryStyles.expirationDateDropdownsItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

creditCardDetailsEntryStyles.expirationDropdownsContainer = {
    css: css`
        display: flex;
        flex: 1;
        gap: 22px;
        width: 100%;
        align-items: end;
        -webkit-align-items: flex-end;
    `,
};

creditCardDetailsEntryStyles.dateError = {
    color: "danger",
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};

creditCardDetailsEntryStyles.link = {
    ...createLinkIconStyles(IconQuestionTooltip, {
        css: css`
            display: flex;
            height: 16px;
            position: relative;
            top: 30px;
            ${IconWrapper} {
                margin: 0;
                margin-left: 4px;
                &,
                & svg {
                    height: auto;
                    width: 16px;
                    height: 16px;
                    opacity: 1;
                }
            }
        `,
    }),
};

// fix firefox issue of textfield border bottom not showing
creditCardDetailsEntryStyles.cardNumberTokenExFrame = creditCardDetailsEntryStyles.securityCodeTokenExFrame = {
    cssOverrides: {
        formInputWrapper: css`
            div[class^="TokenExFrameWrapper"] {
                height: 35px;
            }
        `,
    },
};
